import { createTmpClientId, isClientId } from '@/common/network/gql-types'
import type { PropertyType } from '../gql/PropertyType'

export interface LocalPropDef {
  id: number
  name: string
  type: PropertyType
}

export function newLocalPropDef(name: string, type: PropertyType): LocalPropDef {
  return { id: createTmpClientId(), name, type }
}

export function isNewLocalProp(prop: LocalPropDef): boolean {
  return isClientId(prop.id)
}

export interface ITypeFormController {
  initialCustomProps: LocalPropDef[]
  initialMetaProps: LocalPropDef[]
  onClose(): void
  onSubmit(name: string, customProps: LocalPropDef[]): Promise<string | undefined>
}
